import { Box, Checkbox, Eyebrow, I, Icon, Row, Stack } from '@leanin/ui';
import { useTranslations } from 'use-intl';

// The in-panel consent block (R7 / D2): the two fixed statements every applicant
// must agree to, shown to the leader as an always-present, non-editable preview.
// Rendered as disabled checkboxes so it reads exactly like the applicant step
// without being interactive. Statement copy is placeholder pending Legal
// (D-DEF-3). Distinct from IntakeConsentPreview (the applicant's-eye render
// inside the "Preview form" modal); both share the same statement copy.
export function IntakeConsentNotice() {
  const t = useTranslations('Group');
  return (
    <Box border="hairline" rounded="lg" p="lg" bg="muted">
      <Stack gap="sm">
        <Row gap="xs" align="center">
          <Icon size="sm" color="var(--muted-foreground)">
            {I.lock}
          </Icon>
          <Eyebrow>{t('admin.joinQuestions.consent.alwaysShown')}</Eyebrow>
        </Row>
        <Stack gap="sm">
          <Checkbox
            checked={false}
            onCheckedChange={() => {}}
            disabled
            required
            label={t('intakeForm.consent.statements.share_with_leaders')}
          />
          <Checkbox
            checked={false}
            onCheckedChange={() => {}}
            disabled
            required
            label={t('intakeForm.consent.statements.withdraw_right')}
          />
        </Stack>
      </Stack>
    </Box>
  );
}
